module.exports = __webpack_public_path__ + "img/9788937833229.3c7fca6b.jpg";